import React from "react";
import { Navigate } from "react-router-dom";

/**
 * PageWrapper Component
 * Wraps pages to provide additional functionality, such as user role verification and dynamic routing.
 *
 * @param {Object} props - Component props.
 * @param {string} props.userRole - The current user's role.
 * @param {Object} props.pageParams - Parameters for the dynamic page (e.g., state, grade, subject, view).
 * @param {React.ReactNode} props.children - The content to render if the user is authorized.
 */
const PageWrapper = ({ userRole, pageParams, children }) => {
  const allowedRoles = [
    "administrator",
    "nc-1st-educator",
    "nc-1st-student",
    "nc-2nd-educator",
    "nc-2nd-student",
    "nc-3rd-educator",
    "nc-3rd-student",
    "nc-4th-educator",
    "nc-4th-student",
    "nc-5th-educator",
    "nc-5th-student",
    "ca-1st-educator",

  ]; // Add your specific roles here

  // Check if the user is authorized
  if (!allowedRoles.includes(userRole)) {
    console.warn(`Unauthorized role: ${userRole}`); // Debugging
    return <Navigate to="/unauthorized" replace />;
  }

  // Debugging: Log the page parameters
  console.log("Page parameters:", pageParams);

  // Render the wrapped content
  return <div>{children}</div>;
};

export default PageWrapper;
